<template>
  <div class="worker-id-card-img">
    <div class="img-item">
      <fm-title title-text="正面"></fm-title>
      <div class="img-c" v-loadingx="front.loading" @click="clickImg('front')">
        <img :src="front.src" v-if="front.src" style="width: 100%"/>
        <div v-else class="no-img">
          <div>未上传身份证正面</div>
          <div>点击上传</div>
        </div>
      </div>
    </div>
    <div class="img-item">
      <fm-title title-text="反面"></fm-title>
      <div class="img-c" v-loadingx="back.loading" @click="clickImg('back')">
        <img :src="back.src" v-if="back.src" style="width: 100%"/>
        <div v-else class="no-img">
          <div>未上传身份证反面</div>
          <div>点击上传</div>
        </div>
      </div>
    </div>
    <input type="file" style="display: none;" @change="startUpload" ref="upload">
  </div>
</template>

<script>
import {
  fileRequest
} from '@/api'

export default {
  props: {
    workerData: {
      type: Object
    },
    funs: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      front: {
        loading: false,
        src: null
      },
      back: {
        loading: false,
        src: null
      },
      frontFileId: null,
      backFileId: null,
      uploadType: null
    }
  },
  watch: {
    workerData: {
      handler () {
        this.frontFileId = this.workerData && this.workerData.idCardFrontFileId ? this.workerData.idCardFrontFileId : null
        this.backFileId = this.workerData && this.workerData.idCardBackFileId ? this.workerData.idCardBackFileId : null
      },
      immediate: true,
      deep: true
    },
    frontFileId: {
      handler () {
        this.loadFile('front')
      },
      immediate: true,
      deep: true
    },
    backFileId: {
      handler () {
        this.loadFile('back')
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    clickImg (type) {
      if (this.front.loading || this.back.loading) {
        this.$notice.info({
          title: '系统提示',
          desc: '文件上传中，请稍后。'
        })
        return
      }
      if (!this.funs.update) {
        return
      }
      this.uploadType = type
      this.$refs.upload.click()
    },
    async startUpload () {
      if (!this.funs.update) {
        return
      }
      let files = this.$refs.upload.files
      if (files.length) {
        let file = files[0]
        if (file.type && file.type.includes('image')) {
          let hisFileId = this[this.uploadType + 'FileId']
          if (hisFileId) {
            let res = await this.$dialog.confirm('该照片将被覆盖，是否继续操作?')
            if (!res) {
              return
            }
          }
          this[this.uploadType].loading = true
          let parm = new FormData()
          parm.append('file', file)
          let fileData = await fileRequest.upload(parm)
          await this.$emit('idcardFileChange', {
            type: this.uploadType,
            fileData: fileData
          })
          // if (hisFileId) {
          //   await fileRequest.del({'id': hisFileId})
          // }
          this.$notice.success({
            title: '系统提示',
            desc: '上传完成。'
          })
          this[this.uploadType].loading = false
          this[this.uploadType + 'FileId'] = fileData.id
        } else {
          this.$notice.info({
            title: '系统提示',
            desc: '请选择图片文件。'
          })
        }
      }
    },
    async loadFile (type) {
      this[type].src = null
      if (!this.funs.get || !this[type + 'FileId']) {
        return
      }
      this[type].loading = true
      try {
        let fileData = await fileRequest.download({
          id: this[type + 'FileId']
        })
        if (fileData) {
          const src = await new Promise(resolve => {
            let reader = new FileReader()
            reader.readAsDataURL(fileData)
            reader.onload = () => resolve(reader.result)
          })
          this[type].src = src
        } else {
          this[type].src = null
        }
      } catch (error) {
        this[type].src = null
      }
      this[type].loading = false
    }
  }
}
</script>

<style scoped lang="less">
.img-c {
  height: 19vw;
  width: 30vw;
  justify-content: center;
  align-items: center;
  display: flex;
  border: 1px solid #eee;
  .no-img {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #999;
  }
  img {
    max-height: 19vw;
    max-width: 30vw;
  }
}

.worker-id-card-img {
  display: flex;
  .img-item {
    flex: 1;
  }
}
</style>
